import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "steps__step-number" }
const _hoisted_2 = { class: "steps__step-title-wrapper" }
const _hoisted_3 = { class: "steps__step-title" }
const _hoisted_4 = {
  key: 0,
  class: "steps__step-summary"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["steps__step", ( $setup.is_completed_step ) ? ' steps__step--completed' : ( $setup.is_current_step ) ? ' steps__step--active' : null])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.step.step_number), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($props.step.title), 1 /* TEXT */),
      ($setup.is_completed_step)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            ($setup.form_fields.billing_location)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                  _createTextVNode(" Billing Location: "),
                  _createElementVNode("span", null, _toDisplayString($setup.getBillingLocationLabel( $setup.form_fields.billing_location )), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.production_office)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createTextVNode(" Production Office: "),
                  _createElementVNode("span", null, _toDisplayString($setup.getOfficeLabel( $setup.form_fields.production_office )), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.currency)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createTextVNode(" Currency: "),
                  _createElementVNode("span", null, _toDisplayString($setup.getCurrencyLabel( $setup.form_fields.currency )), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.total)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createTextVNode(" Total project cost: "),
                  _createElementVNode("span", null, _toDisplayString($setup.total), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.is_completed_step)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button button--smaller",
          type: "button",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.setActiveStep( $props.step.step_number )))
        }, " Edit "))
      : ($setup.is_current_step)
        ? (_openBlock(), _createBlock($setup["ProjectScopeFormComponent"], {
            key: 1,
            "step-title": $props.step.title
          }, null, 8 /* PROPS */, ["step-title"]))
        : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}